
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'8-3'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            메뉴 관리 - 온라인문의 {{ $route.query.online_inquiry_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.online_inquiry_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='online_inquiry_title'>타이틀<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'online_inquiry_title'
                maxLength="50"
                placeholder = "타이틀을 입력해 주세요.(50자 이내)"
                v-model="formData.onlineInquiryTitle"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.onlineInquiryTitleError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='online_inquiry_top_status'>상단 공지<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="online_inquiry_top_status"
                v-model="formData.onlineInquiryTopStatus"
              >
                <option value='0'>미공지</option>
                <option value='1'>공지</option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='online_inquiry_write'>작성자<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'online_inquiry_write'
                maxLength="10"
                placeholder = "작성자를 입력해 주세요.(10자 이내)"
                v-model="formData.onlineInquiryWrite"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.onlineInquiryWriteError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='online_inquiry_email'>이메일</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'online_inquiry_email'
                maxLength="50"
                placeholder = "이메일을 입력해 주세요.(50자 이내)"
                v-model="formData.onlineInquiryEmail"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='online_inquiry_views'>조회수</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'online_inquiry_views'
                readonly
                v-model="formData.onlineInquiryViews"
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='online_inquiry_status'>노출 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="online_inquiry_status"
                v-model="formData.onlineInquiryStatus"
              >
                <option value='1'>노출</option>
                <option value='2'>미노출</option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='online_inquiry_security_status'>노출 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="online_inquiry_security_status"
                v-model="formData.onlineInquirySecurityStatus"
              >
                <option value='0'>공개글</option>
                <option value='1'>비밀글</option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='online_inquiry_editor'>내용</label>
              <custom-textarea
                v-model="formData.onlineInquiryEditor"
                :id="'online_inquiry_editor'"
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import CustomTextarea from '../../ETC/CustomTextarea.vue'
import { editorsReady } from '../../ETC/editor/form'
import {
  get_online_inquiry_one,
  insert_online_inquiry,
  update_online_inquiry,
  get_session_admin

} from '../../ETC/Axios.vue'

export default {
  name: 'AdminOnlineInquiryManagementAdd',
  components: {
    AdminHeader,
    AdminFooter,
    Spiner,
    CustomTextarea
  },
  setup () {
    return {
      formData: ref({
        onlineInquiryTitle: '',
        onlineInquiryTopStatus: '0',
        onlineInquiryWrite: '',
        onlineInquiryEmail: '',
        onlineInquiryViews: '0',
        onlineInquiryStatus: 1,
        onlineInquirySecurityStatus: 0,
        onlineInquiryEditor: ''
      }),
      errorData: ref({
        onlineInquiryTitleError: '',
        onlineInquiryWriteError: ''
      }),
      statusData: ref({
        spinnerStatus: false
      })
    }
  },
  methods: {
    check_form: function () {
      // 업로드 중인 이미지가 본문에서 누락되지 않도록 저장 전에 확인한다.
      if (!editorsReady(this)) return
      let continue_add = true
      if (this.formData.onlineInquiryTitle === '') {
        this.errorData.onlineInquiryTitleError = '타이틀을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.onlineInquiryTitleError = ''
      }
      if (this.formData.onlineInquiryWrite === '') {
        this.errorData.onlineInquiryWriteError = '작성자를 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.onlineInquiryWriteError = ''
      }
      if (continue_add) {
        this.statusData.spinnerStatus = true
        if (this.$route.query.online_inquiry_ID === undefined) {
          insert_online_inquiry(
            this.formData.onlineInquiryTitle,
            this.formData.onlineInquiryTopStatus,
            this.formData.onlineInquiryWrite,
            this.formData.onlineInquiryEmail,
            this.formData.onlineInquiryEditor,
            this.formData.onlineInquiryStatus,
            this.formData.onlineInquirySecurityStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('등록이 완료되었습니다.')
            window.location.href = '/AdminOnlineInquiryManagement'
          })
        } else {
          update_online_inquiry(
            this.$route.query.online_inquiry_ID,
            this.formData.onlineInquiryTitle,
            this.formData.onlineInquiryTopStatus,
            this.formData.onlineInquiryWrite,
            this.formData.onlineInquiryEmail,
            this.formData.onlineInquiryEditor,
            this.formData.onlineInquiryStatus,
            this.formData.onlineInquirySecurityStatus
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('수정이 완료되었습니다.')
            window.location.href = '/AdminOnlineInquiryManagement'
          })
        }
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    if (this.$route.query.online_inquiry_ID !== undefined) {
      get_online_inquiry_one(this.$route.query.online_inquiry_ID).then((result) => {
        this.formData.onlineInquiryTitle = result.online_inquiry[0].online_inquiry_title
        this.formData.onlineInquiryTopStatus = result.online_inquiry[0].online_inquiry_top_status
        this.formData.onlineInquiryWrite = result.online_inquiry[0].online_inquiry_write
        this.formData.onlineInquiryEmail = result.online_inquiry[0].online_inquiry_email
        this.formData.onlineInquiryViews = result.online_inquiry[0].online_inquiry_views
        this.formData.onlineInquiryStatus = result.online_inquiry[0].online_inquiry_status
        this.formData.onlineInquirySecurityStatus = result.online_inquiry[0].online_inquiry_security_status
        this.formData.onlineInquiryEditor = result.online_inquiry[0].online_inquiry_editor
      })
    } else {
      get_session_admin().then(result => {
        if (result === '') {
          alert('로그인 유지시간이 만료되었습니다.')
          window.location.href = '/AdminLogin'
        } else {
          this.formData.onlineInquiryWrite = result.admin_name
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/CommunityManagement/AdminOnlineInquiryManagementAdd.vue